import { useSelector } from 'react-redux'
import { Column, GridContainer, H2, Row } from '@vp/swan'
import { getMetadata } from '~/app/store/config/reducer'
import { Markdown } from '~/app/components/Markdown'

export const SecondaryContent = () => {
  const galleryMetadata = useSelector(getMetadata)

  return (
    <GridContainer className="secondary-content-container" component="section">
      <Row>
        <Column span={12} spanLg={10} spanMd={10}>
          <H2>{galleryMetadata?.secondaryHeader}</H2>
        </Column>
      </Row>
      {galleryMetadata?.secondaryContent && (
        <Row>
          <Column span={12} spanLg={10} spanMd={10}>
            <Markdown>{galleryMetadata.secondaryContent}</Markdown>
          </Column>
        </Row>
      )}
    </GridContainer>
  )
}
